// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__x5Euz","canvas":"style_canvas__v3Qsk","button":"style_button__hKvGL"};